import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const NavigationTab = ({ tabs }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const renderTab = (name, path) => {
    const isActivePage = pathname.includes(path);
    return (
      <div className="sm:px-6 w-1/2 sm:w-auto text-center" key={name}>
        <div
          className={classnames(
            'flex px-4 pb-2 justify-center sm:justify-start',
            { 'border-b-4 border-sigmaBlue': isActivePage }
          )}
        >
          <div className="cursor-pointer text-dusty">
            <div
              role="button"
              tabIndex="0"
              className="flex items-center focus:outline-none"
              onClick={() => navigate(path)}
            >
              <div className={classnames({ 'text-sigmaBlue': isActivePage })}>
                {name}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full flex fixed z-10 shadow-card bg-white sm:h-24 items-end">
      {tabs.map(({ name, path }) => renderTab(name, path))}
    </div>
  );
};

NavigationTab.propTypes = {
  tabs: PropTypes.array.isRequired,
};

export default NavigationTab;
